import type { AreaResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toArea } from './toArea';

// Builds a normalized `Data.Area` domain from a list of Area DTOs.
function toAreaDomain(args: { dtos: AreaResponse[] }) {
  const { dtos } = args;

  const areaDomain: NormalizedDomain<Data.Area> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const area = toArea(item);
      domainUtility.mutateAdd(areaDomain, area);
    },
  });

  return { areaDomain };
}

export { toAreaDomain };
